import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, mergeMap, takeUntil } from 'rxjs/operators'

import { createWizardCampaignSelector } from 'containers/AwarenessCenter/constants'
import {
  CHANGE_CREATED_BY_FILTER,
  CHANGE_SORT_BY,
  CHANGE_TYPE_FILTER,
  FETCH_LANDING_PAGES_ASYNC,
} from 'containers/AwarenessCenter/WizardCampaign/steps/LandingPageStep/constants'

import { fetchLandingPagesError, fetchLandingPagesSuccess } from './actions'

const fetchLandingPagesEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_LANDING_PAGES_ASYNC.INITIATE,
      CHANGE_CREATED_BY_FILTER,
      CHANGE_TYPE_FILTER,
      CHANGE_SORT_BY
    ),
    mergeMap(() =>
      api.wizardCampaign
        .getLandingPages(
          state$.value.partnerOptions.selectedCompany?.value,
          createWizardCampaignSelector(state$.value).self.campaign.defaultLocaleId,
          createWizardCampaignSelector(state$.value).self.campaign.selectedLocaleIds,
          createWizardCampaignSelector(state$.value).landingPageStep.createdByFilter,
          createWizardCampaignSelector(state$.value).landingPageStep.typeFilter,
          createWizardCampaignSelector(state$.value).landingPageStep.sortByUsage
        )
        .pipe(
          mergeMap((response) => of(fetchLandingPagesSuccess(response))),
          catchError((error) => of(epicsErrorHandler(fetchLandingPagesError, error))),
          takeUntil(action$.pipe(ofType(FETCH_LANDING_PAGES_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(fetchLandingPagesEpic)
